import { useMapsLibrary } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'

interface Props {
	onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void
	inputRef?: React.RefObject<HTMLInputElement>
}

export const AutoCompleteMap = ({ onPlaceSelect, inputRef }: Props) => {
	const [placeAutocomplete, setPlaceAutocomplete] =
		useState<google.maps.places.Autocomplete | null>(null)
	const places = useMapsLibrary('places')

	useEffect(() => {
		if (!places || !inputRef?.current) return // Safely check if inputRef.current exists

		const options = {
			fields: ['geometry', 'name', 'formatted_address'],
		}

		setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options))
	}, [places, inputRef])

	useEffect(() => {
		if (!placeAutocomplete) return

		placeAutocomplete.addListener('place_changed', () => {
			onPlaceSelect(placeAutocomplete.getPlace())
		})
	}, [onPlaceSelect, placeAutocomplete])

	return null // No need to render anything else since it reuses the parent input
}
